<p-dialog
(onHide)='hide()'
modal="true"
header="Users List" [(visible)]="visibleUsers" 
  [style]="{width: '500px', minWidth: '400px'}" [minY]="50" >
    <p-listbox [options]="staffs" 
    
    (onDblClick)='selectStaff($event)'
    [(ngModel)]="selectedStaff" [listStyle]="{'max-height':'550px',width: '480px', minWidth: '380px'}">
      <ng-template let-user pTemplate="item">
        
        {{user.nom}} 
        <br> 

       
        <mat-divider>
        </mat-divider>
      </ng-template>
   
    </p-listbox>
   
  </p-dialog>
